/**
 * Build with Customer Container
 * Handles data fetching and state management
 */

import React, { useEffect, useState } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { BuildWithCustomerDetails } from "./BuildWithCustomerDetails";
import { IBuildWithCustomerContainerProps } from "./BuildWithCustomer.interfaces";
import { logEvent, logException } from "../../helper/AppInsightsHelper";

export const BuildWithCustomerContainer: React.FC<IBuildWithCustomerContainerProps> = ({
  squadId,
  squadName
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const initializeData = async () => {
      try {
        setIsLoading(true);
        logEvent(
          "BuildWithCustomer container initialized",
          "BuildWithCustomer",
          "BuildWithCustomerContainer",
          { squadId, squadName }
        );

        // Simulate data fetching - In a real scenario, this would be API calls
        // You can replace this with actual API calls using Redux slices or service calls
        const mockDelay = new Promise(resolve => setTimeout(resolve, 500));
        await mockDelay;

        setIsLoading(false);
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : "Unknown error occurred";
        setError(errorMessage);
        logException(
          "BuildWithCustomer",
          "BuildWithCustomerContainer",
          "initializeData",
          err as Error,
          { squadId, squadName }
        );
        setIsLoading(false);
      }
    };

    initializeData();
  }, [squadId, squadName]);

  if (error) {
    return (
      <div style={{ padding: "24px", textAlign: "center" }}>
        <div style={{ color: "#E81123", fontSize: "16px", fontWeight: "600", marginBottom: "12px" }}>
          Error Loading Data
        </div>
        <div style={{ color: "#605E5C", fontSize: "14px" }}>
          {error}
        </div>
      </div>
    );
  }

  return (
    <div>
      {isLoading && (
        <div style={{ display: "flex", justifyContent: "center", padding: "48px" }}>
          <Spinner size={SpinnerSize.large} label="Loading Build with Customer data..." />
        </div>
      )}
      {!isLoading && (
        <BuildWithCustomerDetails
          squadName={squadName || "Alpha Security Squad"}
          squadId={squadId}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};
